import { z } from 'zod';

import { statisticsSummaryValueSchema } from './statistics-summary';

/**
 * Represents the available metrics for the player statistics summary.
 */
export enum PlayerStatisticsSummaryMetric {
  // General Metrics
  TIME = 'TIME', // Total Time
  // Shot Metrics
  EFGP = 'EFGP', // Effective FG%
  FGA = 'FGA', // FGA
  FGP = 'FGP', // FG%
  THREEPA = 'THREEPA', // 3PA
  THREEPP = 'THREEPP', // 3P%
  // Performance Metrics
  DISTANCE = 'DISTANCE', // Distance
  LOAD = 'LOAD', // Load
  NUMBER_SPRINTS = 'NUMBER_SPRINTS', // Number of Sprints
}

export type PlayerStatisticsSummaryValue = z.infer<typeof playerStatisticsSummaryValueSchema>;

/**
 * Represents a summary of statistics data for a player.
 */
export const playerStatisticsSummaryValueSchema = statisticsSummaryValueSchema.extend({
  /** The player ID associated with the statistics */
  playerId: z.uuid(),
});

export type PlayerStatisticsSummary = z.infer<typeof playerStatisticsSummarySchema>;

/**
 * Represents a summary of player statistics, where each metric is mapped to the players' values.
 */
export const playerStatisticsSummarySchema = z.record(
  z.enum(PlayerStatisticsSummaryMetric),
  z.array(playerStatisticsSummaryValueSchema),
);
